import { useEffect, useState } from 'react';
import { useFindByQuery } from '../../graphql';

export const useTagByTagCode = (tagCode: string) => {
  const [tag, setTag] = useState<any>(undefined);
  const variables = {
    tagCode: tagCode,
  };

  const { data, isLoading } = useFindByQuery({
    modelName: 'tag',
    query: FIND_TAG_BY_TAGCODE,
    variables: variables,
    options: {
      enabled: !!tagCode,
      staleTime: 0,
      gcTime: 0,
    },
  });

  useEffect(() => {
    if (!data) return;

    setTag(data.items[0]);
  }, [data]);

  return {
    tag,
    isLoading,
    // `linkData` is hydrated into the linked asset and only resolves assets the
    // caller can read, so a tag claimed in another workspace arrives with a null
    // `linkData`. `type` comes straight off the tag doc.
    isInUse: !!tag?.link?.type,
  };
};

const FIND_TAG_BY_TAGCODE = `
  query FindTags($tagCode: String) {
    findTags(filter: {
      tagCode: { eq: $tagCode}
    }) {
      items {
        id
        tagCode
        link {
          linkData
          type
        }
      }
    }
  }
`;
